import * as React from "react";
function SvgLink(props, svgRef) {
    return (
        <svg
            width="1em"
            height="1em"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={svgRef}
            {...props}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M19.071 4.929a5 5 0 00-7.071 0L9.172 7.757l1.414 1.414 2.828-2.828a3 3 0 114.243 4.243l-2.829 2.828 1.415 1.414L19.07 12a5 5 0 000-7.071zM6.343 13.414l2.121-2.121L7.05 9.879l-2.121 2.12A5 5 0 0012 19.072l2.121-2.121-1.414-1.415-2.121 2.122a3 3 0 11-4.243-4.243zm10.607-4.95L15.536 7.05 7.05 15.536l1.414 1.414 8.486-8.486z"
                fill="currentcolor"
            />
        </svg>
    );
}
const ForwardRef = React.forwardRef(SvgLink);
export default ForwardRef;
